module.exports = __webpack_public_path__ + "img/BZ.87288e2f.png";